/**
 * Updates image URLs in HTML content for legacy/tinyMCE rendering.
 * Transforms /wiki/download/thumbnails/ and /wiki/download/attachments/
 *   to /wiki/download/legacy/thumbnails/ and /wiki/download/legacy/attachments/.
 * Only updates URLs that appear within HTML element attributes, not in text content.
 * This is necessary when attachment-download-blocking data security policies are in place,
 *   as the original download endpoints stop working as image sources.
 */
export function updateLegacyImageUrls(html: string): string {
	if (!html) {
		return html;
	}

	return html.replace(
		/(\w+\s*=\s*["'])([^"']*)(["'])/g,
		(match, prefix, attributeValue, suffix) => {
			if (attributeValue.includes('/wiki/download/')) {
				const updatedValue = attributeValue.replace(
					/\/wiki\/download\/(thumbnails|attachments)\//g,
					'/wiki/download/legacy/$1/',
				);
				return prefix + updatedValue + suffix;
			}
			return match;
		},
	);
}
